var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-md"},[(this.hasAuthenticatedUser)?_c('EditProfileForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }